module.exports = __webpack_public_path__ + "static/media/logo.02b621d9.png";